const mEditionProductPricesAndPlans = {
  mEditionProductPricesAndPlans: {
    alerts: {
      updateProducto: {
        error: 'Un error ha ocurrido. Verifica los datos seleccionados y vuelve a intentarlo.',
        success: 'Los datos del producto fueron editados exitosamente.'
      }
    },

    buttonPrimary: 'GUARDAR',

    inputs: {
      activo: {
        label: {
          checked: 'Venta de producto habilitada',
          unchecked: 'Venta de producto deshabilitada'
        }
      },

      forma: {
        label: {
          first: 'Pago',
          second: 'Gratis'
        }
      },

      trial: {
        label: {
          first: 'Periodo de Prueba Gratis',
          second: 'Sin Periodo de Prueba'
        }
      },

      visible: {
        label: {
          checked: 'Producto visible en tienda de academia',
          unchecked: 'Producto oculto en tienda de academia'
        }
      }
    },

    links: {
      paymentMethod: 'Crear Nuevo Medio de Pago',
      plan: 'Crear Nueva Forma de Pago',
      pointsOfSale: 'Crear Nuevo Punto de Venta'
    },

    messages: {
      // Un producto con IA no se regala ni tiene prueba: cada venta entrega creditos que cuestan plata
      artificialIntelligence: {
        free: '* Un producto con Inteligencia Artificial no puede ser gratis: cada venta entrega créditos de IA.',
        trial: '* Un producto con Inteligencia Artificial no tiene período de prueba: los créditos se entregan desde la compra.'
      },

      active: {
        disabled: {
          assetsIncluded: {
            text: '* Para habilitar la venta debes tener al menos un',
            link: 'curso incluido'
          },
          card: {
            text: '* Para habilitar la venta debes completar el item',
            link: 'tarjeta del producto'
          }
        },
        hidden: '* La venta de tu producto está habilitada mediante el formulario de venta. El producto aún está oculto en el listado de productos en la tienda de academia',
        inactive: '* La venta de tu producto está deshabilitada, su formulario de venta correspondiente no puede ser accedido',
        visible: '* La venta de tu producto está habilitada mediante el formulario de venta y el producto está visible en el listado de productos en la tienda de academia'
      },

      currency: {
        activation: {
          first: '* Para habiltar la moneda',
          second: 'debes completar su configuración'
        },

        items: {
          methods: 'Medios de Pago',
          payments: 'Formas de Pago',
          pointOfSale: 'Punto de Venta',
          state: 'Estado de Activación'
        }
      },

      paymentMethods: {
        noPaymentMethodsCreated: 'Aún no tienes medios de pago creados'
      },

      plan: {
        dues: 'cuotas mensuales de',
        noPlansCreated: 'Aún no tienes formas de pago creadas',
        payout: '1 pago de contado de',
        subscription: {
          first: '1 pago de',
          second: 'cada'
        }
      },

      pointsOfSale: {
        first: '* Estos datos se utilizarán para la facturación de las ventas de tu producto en',
        noPointsOfSaleCreated: 'Aún no tienes puntos de venta creados'
      },

      price: {
        charge: '* Al finalizar la configuración de todos los pasos podrás obtener la url del formulario de venta de tu producto',
        free: '* Las personas podrán acceder al producto de manera gratuita'
      },

      trial: {
        charge: '* En la configuración de cada moneda podrás colocar el monto correspondiente para este periodo de prueba',
        free: '* El alumno comenzará a pagar al término del periodo de prueba',
        non: '* El alumno comenzará a pagar inmediatamente al momento de su registración'
      },

      url: '* Una vez que tus alumnos completen el formulario, recibirán un email de confirmación con los datos de acceso al mismo'
    },

    steps: {
      first: '1. Selecciona una forma de venta para tu producto',

      second: {
        charge: '2. Selecciona un periodo de prueba para tu producto',
        free: '2. Configura el estado de venta de tu producto'
      },

      third: {
        charge: '3. Configura las monedas con las que quieres vender tu producto',
        free: '3. Enlace al formulario de venta de tu producto'
      },

      fourth: '4. Configura el estado de venta de tu producto',
      fifth: '5. Enlace al formulario de venta de tu producto'
    },

    trialText: 'por'
  }
}

export default mEditionProductPricesAndPlans
